if (!customElements.get('pickup-availability-link')) {
  class PickupAvailabilityLink extends HTMLElement {
    constructor() {
      super();
      this.getAvailability(this.dataset.variantId);
    }

    async getAvailability(variantId) {
      let { rootUrl } = this.dataset;

      if (!rootUrl.endsWith('/')) rootUrl = `${rootUrl}/`;

      try {
        const response = await fetch(`${rootUrl}variants/${variantId}/?section_id=pickup-availability-link`);
        if (!response.ok) throw new Error(response.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        if (!tmpl.content.querySelector('.js-availability-link')) {
          this.hideLink();
        } else {
          this.renderPickupInfo(tmpl.content.querySelector('.shopify-section'));
        }

      } catch (error) {
        console.log('error', error)
        // TODO: show error
      }
    }

    hideLink() {
      const link = this.querySelector('.js-availability-link');

      if (link) {
        link.remove();
      }
    }

    renderPickupInfo(sectionHtml) {
      const drawer = document.querySelector('.js-pickup-drawer');

      if (drawer) drawer.remove();

      this.innerHTML = sectionHtml.querySelector('.js-availability-link').outerHTML;
      document.body.appendChild(sectionHtml.querySelector('.js-pickup-drawer'));

      const showDetailsBtn = this.querySelector('.js-show-pickup-info');

      if (showDetailsBtn) {
        showDetailsBtn.addEventListener('click', () => {
          document.querySelector('.js-pickup-drawer').open(showDetailsBtn);
        });
      }
    }
  }

  customElements.define('pickup-availability-link', PickupAvailabilityLink);
}
